/**
 * 法律文本(用户服务协议 / 隐私政策)的结构化内容。
 *
 * ★正文放数据文件而不是写死在页面里:申报材料(docx)与平台页面同源,改一处两边一致。
 *   段落是纯文本;`list` 渲染成项目列表。没有富文本/HTML 注入口。
 */
import { getBrand, type Brand } from "@/shared/brand";

export type LegalBlock = string | { list: string[] };

export interface LegalSection {
  heading: string;
  blocks: LegalBlock[];
}

export interface LegalDoc {
  title: string;
  /** 版本日期,形如「2026年9月28日」 */
  updatedAt: string;
  intro: LegalBlock[];
  sections: LegalSection[];
}

/** 协议里的主体三元组:运营主体 / 产品名 / 联系地址。 */
export interface LegalVars {
  company: string;
  product: string;
  address: string;
}

/**
 * OEM 贴牌:主体口径读当前品牌(shared/brand)。直营 = DEFAULT_BRAND.legal,与改造前三个常量逐字相同;
 * 渠道主体口径(渠道方 / 我方 / 双主体)待法务定,届时由渠道品牌的 legal 字段承接。
 */
export function legalVars(brand: Pick<Brand, "legal"> = getBrand()): LegalVars {
  return { ...brand.legal };
}
